import React from 'react';
import { Button } from 'swag-client-common/components/ui/button';
import { PROCEED_BUTTON_TEXT, PROCEED_BUTTON_DATA_ATTRIBUTE } from 'swag-common/constants/reseller.constants';
import { checkIsPreBuiltCartMode, isPresentationOrInvoiceMode } from 'swag-common/utils/reseller/check-is-reseller-admin-mode.util';
import { CreateResellerCartPopup } from '../../../../../../../popups/create-reseller-prebuild-cart-popup';
import classes from '../../checkout-block.scss';
import { TYPE } from '../../button-type';
export const ProceedButtonComponent = ({
  resellerAdminMode,
  onCheckoutClick,
  onResellerAdminModeBtnClick
}) => {
  if (checkIsPreBuiltCartMode(resellerAdminMode)) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      dataButton: PROCEED_BUTTON_DATA_ATTRIBUTE[resellerAdminMode],
      type: TYPE,
      size: "small",
      onClick: () => onResellerAdminModeBtnClick(resellerAdminMode),
      className: classes.button
    }, PROCEED_BUTTON_TEXT[resellerAdminMode]), /*#__PURE__*/React.createElement(CreateResellerCartPopup, null));
  }
  const buttonLabel = isPresentationOrInvoiceMode(resellerAdminMode) ? 'Proceed to Delivery Address' : 'Proceed to Checkout';
  return /*#__PURE__*/React.createElement(Button, {
    dataButton: "Buy",
    type: TYPE,
    size: "small",
    onClick: onCheckoutClick,
    className: classes.button
  }, buttonLabel);
};